var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccountingCoinsBillMoneyPaymentsFinance = function SvgAccountingCoinsBillMoneyPaymentsFinance(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 16.25C10.0637 16.25 12.75 14.9069 12.75 13.25C12.75 11.5931 10.0637 10.25 6.75 10.25C3.43629 10.25 0.75 11.5931 0.75 13.25C0.75 14.9069 3.43629 16.25 6.75 16.25Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.25V20.25C0.75 21.91 3.44 23.25 6.75 23.25C10.06 23.25 12.75 21.91 12.75 20.25V13.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.75C12.75 18.41 10.06 19.75 6.75 19.75C3.44 19.75 0.75 18.41 0.75 16.75",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75H21.75C22.1478 15.75 22.5294 15.592 22.8107 15.3107C23.092 15.0294 23.25 14.6478 23.25 14.25V2.25C23.25 1.85218 23.092 1.47064 22.8107 1.18934C22.5294 0.908035 22.1478 0.75 21.75 0.75H2.25C1.85218 0.75 1.47064 0.908035 1.18934 1.18934C0.908035 1.47064 0.75 1.85218 0.75 2.25V8.76",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31995 6.90999C9.49422 6.54155 9.74175 6.21248 10.0474 5.94287C10.3531 5.67326 10.7105 5.46876 11.0978 5.34186C11.4851 5.21496 11.8943 5.16832 12.3002 5.20478C12.7062 5.24123 13.1004 5.36003 13.4589 5.55391C13.8175 5.7478 14.1327 6.0127 14.3854 6.33246C14.6382 6.65222 14.8231 7.02013 14.929 7.41373C15.0348 7.80733 15.0593 8.21837 15.001 8.62177C14.9427 9.02516 14.8029 9.41245 14.5899 9.75999",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50488 4.88C4.29778 4.88 4.12988 4.71211 4.12988 4.505C4.12988 4.2979 4.29778 4.13 4.50488 4.13",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50488 4.88C4.71199 4.88 4.87988 4.71211 4.87988 4.505C4.87988 4.2979 4.71199 4.13 4.50488 4.13",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4951 12.3701C19.288 12.3701 19.1201 12.2023 19.1201 11.9951C19.1201 11.788 19.288 11.6201 19.4951 11.6201",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4951 12.3701C19.7022 12.3701 19.8701 12.2023 19.8701 11.9951C19.8701 11.788 19.7022 11.6201 19.4951 11.6201",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccountingCoinsBillMoneyPaymentsFinance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "accounting-coins-bill-money-payments-finance.f169a36d9be980be8bd48ed51f77c0fb.svg";